<template>
<p>{{$t('Tag Info')}}</p>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      selectedTagInfo: {},
    };
  },
  props: ["selectedTagID"],
  provide() {
    return { selectedTagInfo: this.selectedTagInfo };
  },
  methods: {
    updateUserGroup() {
      let payload = {};
      payload.params = { tagId: this.selectedTagID };
      payload.data = this.selectedTagInfo;
      this.updateExistingTag(payload);
    },
    ...mapActions("tags", ["getTagInfoFromServer", "updateExistingTag"]),
  },
  created() {
    let payload = {};
    payload.params = { tagId: this.selectedTagID };
    this.getTagInfoFromServer(payload).then((resp) => {
      this.selectedTagInfo = resp;
    });
  },
};
</script>

